import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import * as components from '../../components'
import { OrganizationDelete } from './OrganizationDelete'
import OrganizationHolidaysPane from './OrganizationHolidaysPane'
import { OrganizationSelector } from './OrganizationSelector'
import {connect, useDispatch, useSelector} from 'react-redux'
import * as rest from '../../services'
import { showErrorToast, showSuccessToast } from '../../state/toasts'
import OrganizationForm from './OrganizationForm'
import FlashMessageForm from './FlashMessageForm'
import {TicketListPage} from "../Tickets";
import BankDetailsForm from "./BankDetails";

const SUPERUSER = 'SUPERUSER'
const expandRowText = {
  display: 'inline',
  paddingLeft: '8px',
  marginBottom: '8px',
}
export const OrganizationsDataGrid = ({
  results,
  page_size,
  current,
  count,
  onTableChange,
  onFilter,
}) => {
  const dispatch = useDispatch()
  const { user } = useSelector((state) => state.auth)
  const organizationRowStyle = (organization, rowIndex) => {
    return organization.is_deleted
      ? { borderLeft: '10px solid red' }
      : { borderLeft: '10px solid green' }
  }
  const onAdd = (values) => {
    const promise = new rest.OrganizationService().makePostRequest(values)
    promise
      .then((response) => {
        dispatch(
          showSuccessToast(
            'Added the organization',
            `${response.code} has been added`
          )
        )
        onFilter()
      })
      .catch((errors) => {
        dispatch(
          showErrorToast(
            'Could not add organization',
            JSON.stringify(errors.response ? errors.response.data : errors)
          )
        )
      })
  }
  const onUpdate = (values) => {
    const promise = new rest.OrganizationService(values.url).makePutRequest(
      values
    )
    promise
      .then((response) => {
        dispatch(
          showSuccessToast(
            'Updated the organization',
            `${response.code} has been updated`
          )
        )
        onFilter()
      })
      .catch((errors) => {
        dispatch(
          showErrorToast(
            'Could not update organization',
            JSON.stringify(errors.response ? errors.response.data : errors)
          )
        )
      })
  }

  const onBankDetailsUpdate = (organization,values) => {
    const promise = new rest.OrganizationService(organization.url).add_bank_details(
      values
    )
    promise
      .then((response) => {
        dispatch(
          showSuccessToast(
            'Updated the organization with Bank Details',
            ` Bank Details has been updated`
          )
        )
        onFilter()
      })
      .catch((errors) => {
        dispatch(
          showErrorToast(
            'Could not update  Bank Details',
            JSON.stringify(errors.response ? errors.response.data : errors)
          )
        )
      })
  }
  const onSendFlashMessage = (values, organization) => {
    const promise = new rest.OrganizationService(organization.url)
      .send_flash_message(values)
      .then(() => {
        promise
          .then((response) => {
            dispatch(
              showSuccessToast(
                'Flash Message Sent ',
                `Flash Message has been Sent`
              )
            )
            onFilter()
          })
          .catch((errors) => {
            dispatch(
              showErrorToast(
                'Could not send flash message for the  organization',
                JSON.stringify(errors.response ? errors.response.data : errors)
              )
            )
          })
      })
  }


  const actionFormatter = (cell, row) => {
    const FormOrganization = connect((state) => ({
      initialValues: row,
    }))(OrganizationForm)
    const FormBankDetails = connect((state) => ({
      initialValues: row.bank_details[0],
    }))(BankDetailsForm)
    return (
      <div onClick={(e) => e.stopPropagation()}>
        <ReactBootstrap.Dropdown>
          <ReactBootstrap.Dropdown.Toggle
    variant="dark"
    size="sm"
    />
          <ReactBootstrap.Dropdown.Menu>
            <components.Slider
                buttonType="dropdown"
                title={<span>{components.ICONS.EDIT} Edit</span>}
                header={
                  <span className="pr-3">
                  {components.ICONS.EDIT} Editing
                  <span className="pl-1"> {row.code}</span>
                </span>
                }
            >
              <FormOrganization onSubmit={onUpdate}/>
            </components.Slider>

            <components.Slider
                buttonType="dropdown"
                title={<span>{components.ICONS.RUPEE} Bank Details</span>}
                header={
                  <span className="pr-3">
                  {components.ICONS.EDIT} Bank Details
                  <span className="pl-1"> {row.code}</span>
                </span>
                }
            >
              <FormBankDetails onSubmit={(v)=>onBankDetailsUpdate(row,v)}/>
            </components.Slider>


            <components.Slider
                buttonType="dropdown"
                title={<span>{components.ICONS.COMMENTS} Send Flash </span>}
                header={
                  <span className="pr-3">
                  {components.ICONS.COMMENTS} Send Flash
                  <span className="pl-1"> {row.code}</span>
                </span>
                }
            >
              <FlashMessageForm
                  organization={row}
                  onSubmit={(values) => onSendFlashMessage(values, row)}
              />
            </components.Slider>

            <OrganizationHolidaysPane organization={row}/>
            <OrganizationSelector organization={row}/>
            <ReactBootstrap.NavDropdown.Item
                onClick={() => {
                  const promise = new rest.OrganizationService(row.url)
                      .send_test_email()
                      .then(() => {
                        promise
                            .then((response) => {
                              dispatch(
                                  showSuccessToast(
                                      'Test Email Sent ',
                                      `Test Email has been Sent`
                                  )
                              )
                              onFilter()
                            })
                            .catch((errors) => {
                              dispatch(
                                  showErrorToast(
                                      'Could not send test email for the  organization',
                                      JSON.stringify(
                                          errors.response ? errors.response.data : errors
                                      )
                                  )
                              )
                            })
                      })
                }}
                block
                size="sm"
            >
              {components.ICONS.EMAIL}{' '}
              <span className="ml-1">Send test email</span>
            </ReactBootstrap.NavDropdown.Item>

            {user.role.toUpperCase() === SUPERUSER && <OrganizationDelete organization={row} onDeletion={onFilter}/>}
            <components.Slider
                title={<span>{components.ICONS.VIEW}Tickets</span>}
                header={
                  <span>
                  {components.ICONS.VIEW}Tickets for{' '}
                    <span className="pl-2">{row.code}</span>{' '}
                </span>
                }
                buttonType="dropdown"
            >
              <TicketListPage defaultFilters={{organization: row.code}}/>
            </components.Slider>
          </ReactBootstrap.Dropdown.Menu>
        </ReactBootstrap.Dropdown>
      </div>
    )
  }
  const columns = [
    {
      dataField: 'name',
      text: 'Name',
      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldType: 'text',
    },
    {
      dataField: 'code',
      text: 'Code',
      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldType: 'text',
    },
    {
      dataField: 'org_type',
      text: 'Type',
      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldType: 'text',
    },
    {
      dataField: 'email',
      text: 'Email',
      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldType: 'text',
    },
    {
      dataField: 'contact_number',
      text: 'Contact Number',
      hidden: true,
      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldType: 'text',
    },
    {
      dataField: 'gsx_ship_to',
      text: 'Ship To',
      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldType: 'text',
    },
    {
      dataField: 'city',
      text: 'City',
      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldType: 'text',
      hidden: true,
    },
    {
      dataField: 'token_machine_location_code',
      text: 'Token Machine Code',
      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldType: 'text',
      hidden: true,
    },
    {
      dataField: 'manager_name',
      text: 'Manager',
      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldType: 'text',
    },
    {
      dataField: 'created_at',
      text: 'Created On',
      type: 'string',
      formatter: components.CellDateFormatter,
      searchFieldType: 'date',
    },
    {
      dataField: 'url',
      text: 'Change Log',
      formatter: components.ChangeLogFormatter,
    },
    {
      dataField: '',
      text: '',
      isDummyField: true,
      formatter: actionFormatter,
    },
  ]
  return (
    <ReactBootstrap.Card>
      <ReactBootstrap.Card.Header className="card-header bg-dark text-white">
        <ReactBootstrap.Row>
          <ReactBootstrap.Col xs={6}>Organizations</ReactBootstrap.Col>
          <ReactBootstrap.Col className="text-end" xs={6}>
            <components.Slider
              size="sm"
              sliderWidth={"20vw"}
              title={components.ICONS.SEARCH}

              header={
                <span className="pr-3">
                  {components.ICONS.SEARCH}
                  <span className="pl-1"> Organizations</span>
                </span>
              }
            >
              <components.GenericSearchForm
                onFilter={onFilter}
                columns={columns}
              />
            </components.Slider>
            <components.Slider
              size="sm"
              title={components.ICONS.PLUS}
                  sliderWidth={"75vw"}
              header={
                <span className="pr-3">
                  {components.ICONS.PLUS} Adding
                  <span className="pl-1"> Organization</span>
                </span>
              }
            >
              <OrganizationForm onSubmit={onAdd} />
            </components.Slider>
          </ReactBootstrap.Col>
        </ReactBootstrap.Row>
      </ReactBootstrap.Card.Header>
      <ReactBootstrap.Card.Body>
        <components.DataGrid
          data={results || []}
          rowStyle={organizationRowStyle}
          sizePerPage={page_size || 10}
          page={current || 1}
          columns={columns}
          count={count || 0}
          onTableChange={onTableChange}
          expandRow={{
            renderer: (row) => (
              <ReactBootstrap.Row>
                <ReactBootstrap.Col className="p-0">
                  <dl>
                    <dt style={expandRowText}>Timings</dt>:
                    <dd style={expandRowText}>{row.timings} </dd>
                    <br />
                    <dt style={expandRowText}>Address</dt>:
                    <dd style={expandRowText}>{row.address} </dd>
                  </dl>
                </ReactBootstrap.Col>
                <ReactBootstrap.Col className={' p-0 text-left'}>
                  <dl>
                    <dt style={expandRowText}>City</dt>:
                    <dd style={expandRowText}>{row.city} </dd>
                    <br />
                    <dt style={expandRowText}>State</dt>:
                    <dd style={expandRowText}>{row.state} </dd>
                  </dl>
                </ReactBootstrap.Col>
                <ReactBootstrap.Col
                  style={{ paddingRight: '2rem' }}
                  className={'p-0 text-end'}
                >
                  <dl>
                    <dt style={expandRowText}>Contact Number</dt>:
                    <dd style={expandRowText}>{row.contact_number} </dd>
                    <br />
                    <dt style={expandRowText}>Token Machine Code</dt>:
                    <dd style={expandRowText}>
                      {row.token_machine_location_code}
                    </dd>
                  </dl>
                </ReactBootstrap.Col>
              </ReactBootstrap.Row>
            ),
          }}
        />
      </ReactBootstrap.Card.Body>
    </ReactBootstrap.Card>
  )
}
